/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closed_Caption_EmbedInputs */

const en_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Embed`)
};

const fr_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration de sous-titres`)
};

const de_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel einbetten`)
};

const it_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora sottotitoli`)
};

const ru_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить субтитры`)
};

const es_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar subtítulos cerrados`)
};

const zh_cn2_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏式字幕嵌入`)
};

const ja_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クローズドキャプションの埋め込み`)
};

const hi_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद कैप्शन एम्बेड करें`)
};

const pt_pt2_closed_caption_embed = /** @type {(inputs: Closed_Caption_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas`)
};

/**
* | output |
* | --- |
* | "Closed Caption Embed" |
*
* @param {Closed_Caption_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const closed_caption_embed = /** @type {((inputs?: Closed_Caption_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closed_Caption_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_closed_caption_embed(inputs)
	if (locale === "de") return de_closed_caption_embed(inputs)
	if (locale === "it") return it_closed_caption_embed(inputs)
	if (locale === "ru") return ru_closed_caption_embed(inputs)
	if (locale === "es") return es_closed_caption_embed(inputs)
	if (locale === "zh-CN") return zh_cn2_closed_caption_embed(inputs)
	if (locale === "ja") return ja_closed_caption_embed(inputs)
	if (locale === "hi") return hi_closed_caption_embed(inputs)
	if (locale === "pt-PT") return pt_pt2_closed_caption_embed(inputs)
	return en_closed_caption_embed(inputs)
});